module.exports = __webpack_public_path__ + "static/img/taipingyang.e459694.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/taipingyang.png
// module id = /8eZ
// module chunks = 1